<template>
    <div>
        <el-card class="dashboard-card"
                 v-loading="isLoading">
            <div slot="header">
                <h3 class="cart-title"><i class="el-icon-goods"></i> 디자인 가능한 상품 목록</h3>
            </div>

            <p class="desc--warning"><i class="el-icon-warning-outline"></i> 상품의 가격 및 사이즈는 [커스터마이징 상품]과 동일하게 생성됩니다.</p>
            <el-table :data="productList"
                      style="width: 100%">
                <el-table-column prop="name"
                                 label="상품명"
                                 width="180">
                </el-table-column>
                <el-table-column label="상품타입">
                    <template slot-scope="scope">
                        <el-tag type="info"
                                effect="dark">PDIY:{{scope.row.productType}}
                        </el-tag>
                    </template>
                </el-table-column>
<!--                <el-table-column label="기본가격"-->
<!--                                 width="180">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{scope.row.basePrice | numberWithComma}}원-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="사이즈 옵션">-->
<!--                    <template slot-scope="scope">-->
<!--                        <p v-for="size in scope.row.sizeList"-->
<!--                           :key="size.sizeName">-->
<!--                            <el-tag effect="plain"-->
<!--                                    size="mini"-->
<!--                                    type="warning">{{size.sizeName}}<span v-if="size.additionPrice !== 0"> ({{size.additionPrice > 0 ? '+' : '-'}}{{size.additionPrice | numberWithComma}}원)</span>-->
<!--                            </el-tag>-->
<!--                        </p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <div slot="empty" class="empty-area">
                    <i class="el-icon-scissors"></i>
                    <p class="desc--empty">현재 디자인 가능한 상품이 없습니다.<br/>앱 관리자가 허가한 상품만 디자인 에디터를 사용할 수 있습니다.</p>
                </div>
            </el-table>
        </el-card>
    </div>
</template>

<script>
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'Cafe24ProductList',
        data() {
            return {
                isLoading: false,
                productList: [],
            };
        },
        computed: {
            mall() {
                return this.$store.state.cafe24.mall;
            },
            authToken() {
                return this.$store.state.auth.authToken;
            },
        },
        methods: {
            async getProductList() {
                try {
                    this.isLoading = true;
                    const {data: productList} = await PrintingDiyRepository.getPartnerProductList(this.mall.mallId, this.authToken);
                    this.productList = productList;
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.isLoading = false;
                }
            },
        },
        async created() {
            await this.getProductList();
        },
    };
</script>

<style lang="scss" scoped>
    .desc--warning {
        color: #f56c6c;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;

        i {
            font-size: 16px;
        }
    }

    .empty-area {
        color: #f56c6c;
        padding: 40px 0;

        i {
            font-size: 40px;
            line-height: 40px;
        }

        .desc--empty {
            font-size: 16px;
            font-weight: bold;
            line-height: 28px;
        }
    }
</style>